import CreditSVG from "@/../../hypetrain/static/img/credit.svg";
import { EmbedSvg } from "@/components/helpers/ui/EmbedSvg";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover";
import { LedgerAccountType } from "@/graphql";
import { formatCredits, parseDecimal } from "@/utils/string";

interface AccountListProps {
  ledgerAccounts: LedgerAccountType[];
}

function AccountList({ ledgerAccounts }: AccountListProps) {
  return (
    <div className="w-64 max-w-full">
      {ledgerAccounts.map((account, i) => (
        <div key={`acc-${account.id}`} className={i > 0 ? "mt-3" : ""}>
          <div className="font-medium">{account.label}</div>
          <div className="flex items-center text-sm text-muted-foreground">
            <EmbedSvg src={CreditSVG} height={12} width={12} />
            <span className="ml-2">{formatCredits(account.balance)}</span>
          </div>
        </div>
      ))}
    </div>
  );
}

interface CreditsWithAccountsPopoverProps {
  ledgerAccounts: LedgerAccountType[];
  totalBalance?: number;
}

export function CreditsWithAccountsPopover({
  ledgerAccounts,
  totalBalance,
}: CreditsWithAccountsPopoverProps) {
  const total =
    totalBalance ||
    ledgerAccounts.reduce(
      (acc, account) => acc + parseDecimal(account.balance),
      0,
    );

  return (
    <Popover>
      <PopoverTrigger asChild>
        <div className="flex items-center w-fit border-b border-dashed border-muted-foreground cursor-help break-words py-1">
          <EmbedSvg src={CreditSVG} height={14} width={14} />
          <span className="ml-2">{formatCredits(total)}</span>
        </div>
      </PopoverTrigger>
      <PopoverContent className="w-auto" align="start">
        <AccountList ledgerAccounts={ledgerAccounts} />
      </PopoverContent>
    </Popover>
  );
}
